import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import { Form } from 'antd';
import { VersionNameField } from './components/VersionNameField';
import { VersionCodeField } from './components/VersionCodeField';
import { DescriptionField } from './components/DescriptionField';
import ApplicationIdField from './components/ApplicationIdField';
import ParameterOfApkTypeSelect from './components/ParameterOfApkTypeSelect';
import ApkTypeField from './components/ApkTypeField/ApkTypeField';
import ApkSettingsBlock from './components/ApkSettingsBlock';
import BtnBlock from './components/BtnBlock';
import { preventDefaultForEnterKey } from 'utils/helpers';
import { EditApkContext, IEditApkContext } from 'modules/FirmwareAndApp/Apk/EditApk/editApkState/editApkContext';
import style from './InputFields.module.scss';

const InputFields: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		changeVersionName,
		changeVersionCode,
		changeDescription,
		changeApplicationId,
		setParameterOfApkType,
		setIDApkType,
		toggleCutoverBeforeUpdate,
		apkID,
		versionName,
		versionCode,
		description,
		applicationId,
		parameterOfApkType,
		IDSelectedApkType,
		isCutoverBeforeUpdate,
		fileData,
	} = useContext<IEditApkContext>(EditApkContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ versionName });
		form.setFieldsValue({ versionCode });
		form.setFieldsValue({ description });
		form.setFieldsValue({ applicationId });
		form.setFieldsValue({ parameterOfApkType });
		form.setFieldsValue({ IDSelectedApkType });
		form.setFieldsValue({ isCutoverBeforeUpdate });
	}, [
		versionName,
		versionCode,
		description,
		applicationId,
		parameterOfApkType,
		IDSelectedApkType,
		isCutoverBeforeUpdate,
	]);

	const submit = async () => {
		setDataForSubmit({
			id: apkID,
			versionName,
			versionCode: Number(versionCode),
			description,
			applicationId,
			type: IDSelectedApkType || 1,
			isCutoverBeforeUpdate,
			fileId: fileData.fileId,
			fileHash: fileData.fileHash,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<VersionNameField changeVersionName={changeVersionName} />
					<VersionCodeField changeVersionCode={changeVersionCode} />
					<DescriptionField changeDescription={changeDescription} />
					<ApplicationIdField changeApplicationId={changeApplicationId} />
					<ParameterOfApkTypeSelect setParameterOfApkType={setParameterOfApkType} />
					<ApkTypeField
						parameterOfApkType={parameterOfApkType}
						IDSelectedApkType={IDSelectedApkType}
						isCutoverBeforeUpdate={isCutoverBeforeUpdate}
						setIDApkType={setIDApkType}
						toggleCutoverBeforeUpdate={toggleCutoverBeforeUpdate}
					/>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="apkFileHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<ApkSettingsBlock />
				</div>
				<BtnBlock />
			</Form>
		</div>
	);
};

export default InputFields;
